module.exports = __webpack_public_path__ + "static/media/sign-up-bg.0734a53d.png";